import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { BloqueioAgendaResponse } from '../api/dto/bloqueio-agenda-response';
import { BloqueioAgendaRequest, BloqueioAgendaUpdateRequest } from '../api/dto/bloqueio-agenda-request';

@Injectable({
    providedIn: 'root'
})
export class BloqueioAgendaService{

    constructor(private http: HttpClient) { }

     private url: string = UrlServidor.URL_BASE + 'bloqueios-agenda';

    buscarPorId(bloqueioId: number): Observable<BloqueioAgendaResponse> {
        return this.http.get<BloqueioAgendaResponse>(this.url + "/" + bloqueioId);
    }
    
    listarPorEmpresaId(empresaId?: number): Observable<BloqueioAgendaResponse[]> {
        return this.http.get<BloqueioAgendaResponse[]>(this.url + "/empresa/" + empresaId);
    }

    listarPorEmpresaIdEDataBloqueio(empresaId?: number, dataBloqueio?: string): Observable<BloqueioAgendaResponse[]> {
        return this.http.get<BloqueioAgendaResponse[]>(this.url + "/empresa/" + empresaId + "/data-bloqueio/" + dataBloqueio);
    }

    salvar(bloqueioAgenda?: BloqueioAgendaRequest): Observable<BloqueioAgendaResponse> {
        return this.http.post<BloqueioAgendaResponse>(this.url, bloqueioAgenda);
    }

    salvarBloqueioParcial(bloqueioAgenda?: BloqueioAgendaRequest): Observable<BloqueioAgendaResponse> {
        return this.http.post<BloqueioAgendaResponse>(this.url + "/parcial", bloqueioAgenda);
    }

    reagendar(id: number, bloqueioResquest: BloqueioAgendaUpdateRequest): Observable<void> {
        return this.http.put<void>(`${this.url}/${id}/reagendar`, bloqueioResquest);
    }

    excluir(bloqueioAgendaId: number) {
        return this.http.delete<void>(`${this.url}/${bloqueioAgendaId}`);
    }

}